import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';
import { BackEndWrapper } from './components/backend-wrapper/backend-wrapper';
import './i18n';
import { ConfigProvider } from 'antd';

domReady(() => {
	const root = createRoot(document.getElementById('bookr-admin'));
	root.render(
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: '#0396f9',
				},
			}}
		>
			<BackEndWrapper />
		</ConfigProvider>
	);
});
